import type { FC } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { selectedUnit } from '../../redux/reducers/unitSlice';
import {
  resolveUnitBaseColor,
  unitFoundationsCardColors,
} from '../../businessLogicService/StudentDashboardAux/getColorByUnit';
import UnitCompletedIcon from '../../assets/UnitCompletedIcon.svg?react';

interface Props {
  // Tinted (lit) with the unit's colors once every Target skill is passed; otherwise the pill keeps the
  // default stone look of the locked dashboard connectors' end nodes.
  tinted: boolean;
  // Scales the pill down to fill its container instead of the icon's intrinsic 214x58, for the narrow
  // slot next to the unit-header progress bar.
  compact?: boolean;
}

// The pill-shaped "Completed U.<unit name>" marker: the UnitCompletedIcon with the label overlaid on top.
// Shared by the end-of-path banner (DashboardCompletedBanner) and the unit header's segment indicator.
export const UnitCompletedPill: FC<Props> = ({ tinted, compact = false }) => {
  const unit = useAppSelector(selectedUnit);
  const unitColors = unitFoundationsCardColors[resolveUnitBaseColor(unit?.name)];

  return (
    <div className={`tw-relative tw-inline-flex tw-items-center tw-justify-center ${compact ? 'tw-w-full' : ''}`}>
      <UnitCompletedIcon
        className={`${
          tinted ? `${unitColors.svgFill} ${unitColors.svgStroke}` : 'tw-fill-stone-50 tw-stroke-stone-100'
        } ${compact ? 'tw-h-auto tw-w-full' : ''}`}
      />
      <span
        className={`tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-font-bold ${
          compact ? 'tw-text-xs' : 'tw-text-lg'
        } ${tinted ? 'tw-text-white' : 'tw-text-stone-300'} tw-font-['Atkinson_Hyperlegible']`}
      >
        Completed U.{unit?.name}
      </span>
    </div>
  );
};
